import script from "./Taxonomy.vue?vue&type=script&setup=true&lang=js"
export * from "./Taxonomy.vue?vue&type=script&setup=true&lang=js"

export default script